import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { images } from "@/config/images";

export default function About() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-24 md:pt-28 pb-16">
        {/* ページタイトル */}
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14 text-center">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-accent-700 bg-accent-100 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-heart-line"></i>
              MEGURIの想い
            </p>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              株式会社MEGURIについて
            </h1>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 md:px-6 mt-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            {/* メインメッセージ */}
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-600 leading-snug">
                「命をいただくからこそ、
                <br />
                最後まで無駄にしない。」
              </h2>
              <div className="mt-6 space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
                <p>
                  猟師さんが捕獲した猪。
                  <br />
                  その大切な命を、どうにか無駄にせず、次の形へとつなげたい。
                  <br />
                  そんな想いから、株式会社MEGURIは生まれました。
                </p>
                <p>
                  猟師さんから連絡をいただくと、私たちは自ら現場へ向かい、止め刺し、血抜き、そして精肉まで、一つひとつ責任を持って行っています。
                </p>
                <p>
                  すべての工程を一人で行っているため、ご連絡や発送が遅れてしまうこともあります。
                  それでも、いただいた命と向き合い、できる限り丁寧に、最後まで大切に届けることを心がけています。
                </p>
                <p>
                  そして、私たちが大切にしているのはお肉だけではありません。
                  お肉として届けることができる部分はもちろん、皮も大切な「命のカケラ」。
                  猪の皮はレザーとして生まれ変わり、小物など新しい形へと姿を変えています。
                </p>
                <p className="font-bold text-foreground-950">
                  「お肉も、皮も、できる限り無駄にしない。」
                </p>
                <p>
                  一つの命から生まれたものを、できるだけ余すことなく次の誰かへつないでいく。
                  それが、私たち株式会社MEGURIが大切にしている「命の循環」です。
                </p>
                <p>
                  いただいた命に、最後まで向き合う。
                  そして、その命を次の誰かへつないでいく。
                  これからも、そんな仕事を続けていきます。
                </p>
              </div>
            </div>

            {/* キャラクター画像 */}
            <div className="flex justify-center lg:justify-end">
              <div className="w-full max-w-xs md:max-w-sm">
                <div className="aspect-[3/4] rounded-lg overflow-hidden border border-background-200 bg-background-100">
                  <img
                    src={images.character}
                    alt="株式会社MEGURI 猪のキャラクターイラスト"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}